import { useContext, createContext } from "react";
import type { OnlineStatus } from "../hooks/useOnlineStatus";

// Create context with default value
export const OnlineStatusContext = createContext<OnlineStatus>({
  isOnline: false,
  connectionQuality: 'offline',
});

// Custom hook for consuming the context
export const useOnlineStatusContext = (): OnlineStatus => {
  return useContext(OnlineStatusContext);
}; 